import Client from './client';

export default class BillingOrganizationProcessingRates extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/billing_organization_processing_rates`, options);
  }

  put(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/billing_organization_processing_rates`, {
      ...options,
       method: 'PUT',
    });
  }

}
